module.exports = ".consent-text {\n    white-space: pre-line;\n}"